import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FormatSettings } from '@progress/kendo-angular-dateinputs';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import moment from 'moment';

@Component({
  selector: 'app-review-or-request-for-extension-dialog',
  templateUrl: './review-or-request-for-extension-dialog.component.html',
  styleUrls: ['./review-or-request-for-extension-dialog.component.scss'],
  standalone: false
})
export class ReviewOrRequestForExtensionDialogComponent
  extends DialogContentBase
  implements OnInit {
  form: FormGroup;
  assessmentName: string;
  evaluationSk: string;
  isReview: boolean;
  public format: FormatSettings = {
    displayFormat: 'MM/dd/yyyy',
    inputFormat: 'MM/dd/yyyy',
  };
  readonly reject: string = 'reject';
  readonly approve: string = 'approve';
  readonly minDueDays: number = 0;
  readonly maxDueDays: number = 30;

  constructor(
    private fb: FormBuilder,
    dialog: DialogRef,
    library: FaIconLibrary
  ) {
    super(dialog);
    library.addIcons(faXmark);
  }
  ngOnInit(): void {
    this.form = this.fb.group({
      dueDate: [null],
      extensionDays: [
        { value: null, disabled: this.isReview },
        [Validators.required],
      ],
      requestedDueDate: [{ value: null, disabled: true }],
      extensionReason: [
        { value: null, disabled: this.isReview },
        [Validators.required],
      ],
      extensionAdditionalInfo: [
        { value: null, disabled: this.isReview },
        [Validators.required],
      ],
      action: [null, [Validators.required]],
      approvedDays: [null, [Validators.required]],
      newDueDate: [{ value: null, disabled: true }],
      rejectionReason: [null, [Validators.required]],
      rejectionAdditionalInfo: [null, [Validators.required]],
    });
    this.form.get('approvedDays').valueChanges.subscribe((days: number) => {
      this.setDueDate(days, 'newDueDate');
    });
    this.form.get('extensionDays').valueChanges.subscribe((days: number) => {
      this.setDueDate(days, 'requestedDueDate');
    });
  }

  public close(): void {
    this.dialog.close();
  }

  onAction(actionType: string): void {
    this.form?.get('action').patchValue(actionType);
  }

  setDueDate(days: number, control: string): void {
    if (days > this.minDueDays && days <= this.maxDueDays) {
      this.form
        .get(control)
        .patchValue(moment(new Date()).add(days, 'day').toDate());
    }
  }
}
